import { render } from "./UnifiedAnalytics.vue?vue&type=template&id=5831c845&scoped=true"
import script from "./UnifiedAnalytics.vue?vue&type=script&lang=js"
export * from "./UnifiedAnalytics.vue?vue&type=script&lang=js"

import "./UnifiedAnalytics.vue?vue&type=style&index=0&id=5831c845&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5831c845"]])

export default __exports__